(function () {
    'use strict';
    ImageGalleryController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageDataExtended', '$timeout'];

    function ImageGalleryController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageDataExtended, $timeout) {
//
        var $ctrl = this;
        var preparedImageList = [];

        $ctrl.preparedImageList = preparedImageList;
        var imageList = [];
        $ctrl.delete = function (index) {

            if ($ctrl.methods && $ctrl.methods.delete) {
                $ctrl.methods.delete($ctrl.imageList[index]);
            }

        }
        $scope.$watch('$ctrl.imageList', function (images) {

            $timeout(function () {
                if (images) {
                    preparedImageList = [];

                    angular.forEach(images, function (img) {
                        //console.log(img);
                        var title = img.caption;
                        if (img.description)
                            title = title + ":" + img.description;

                        preparedImageList.push({url: $ctrl.imagesrc(img), title: title});

                    });
                    $ctrl.preparedImageList = preparedImageList;
                    // $ctrl.addImageThumb();

                }
            }, 0);


        }, true)


        $ctrl.currentImage = {};
        $ctrl.imagesrc = function (img) {
            //
            if (img.thumbnailData)
                return DataUtils.imagesrc(img.fileDataContentType, img.thumbnailData);
            else
                return DataUtils.imagesrc(img.fileDataContentType, img.fileData);
        }

        $ctrl.addImageThumb = function () {
            $ctrl.defaultImage = $ctrl.preparedImageList[0];
            if ($ctrl.defaultImage) {
                var image = $ctrl.defaultImage.thumbUrl || $ctrl.defaultImage.url;
                // var node = document.createElement("div");
                //
                // node.id = 'imageThumb';
                // node.classList.add('pl-image-thumb');
                // node.style.backgroundImage = 'url('+image + ')';
                // node.ngClick = $ctrl.openImage();
                //
                var url = 'url(' + image + ')';

                var preview = document.getElementById("preview");
                preview.innerHTML += '<div class="pl-image-thumb" '
                    + ' style="background-image:' + url + '">' + '</div>';


            }
        }

        $ctrl.openImage = function () {
            console.log('sssssss');
        }

    }


    var ImageGallery = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-gallery/eyeson.image-gallery.html',
        controller: ImageGalleryController,
        bindings: {
            imageList: '<',
            methods: '=?'


        }

    };

    angular
        .module('tikonApp')
        .component('eoImageGallery', ImageGallery)


})();

